import React from "react";

import { ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useTheme } from "@mui/material";

interface ISidebarListItemProperties {
  count: number;
  handleListItemClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => void;
  icon: React.ReactElement;
  index: number;
  selectedIndex: number;
  text: string;
}

export default function SidebarListItem({
  count,
  handleListItemClick,
  icon,
  index,
  selectedIndex,
  text,
}: ISidebarListItemProperties) {
  const theme = useTheme();
  return (
    <React.Fragment>
      <ListItem
        disablePadding
        divider
        sx={{
          bgcolor: selectedIndex === index ? theme.palette.secondary.dark : "inherit",
          color: selectedIndex === index ? theme.palette.common.white : theme.palette.text.secondary,
          py: 0.75,
        }}
      >
        <ListItemButton
          onClick={(event) => handleListItemClick(event, index)}
          selected={selectedIndex === index}
          sx={{ display: "flex", gap: 2, justifyContent: "flex-start", ml: 2, mr: 2, py: 1 }}
        >
          <ListItemIcon sx={{ color: selectedIndex === index ? theme.palette.primary.main : "inherit", minWidth: 0 }}>
            {icon}
          </ListItemIcon>
          <ListItemText
            primary={<Typography>{`${text} (${count})`}</Typography>}
            sx={{ alignItems: "center", display: "flex", flex: "none", marginBottom: 0, marginTop: 0, minWidth: 0 }}
          />
        </ListItemButton>
      </ListItem>
    </React.Fragment>
  );
}
